import { ASSETS, BRAND_LINKS } from '@airhead-games/shared/configs';
import { SITE_URL } from '../resolveSEO';

export const buildOrganization = () => ({
  '@type': 'Organization',
  '@id': `${SITE_URL}/#organization`,
  name: 'Airhead Games',
  url: SITE_URL,
  logo: {
    '@type': 'ImageObject',
    url: ASSETS.ogImage,
    width: 1200,
    height: 630,
  },
  contactPoint: {
    '@type': 'ContactPoint',
    email: 'poppy@airheadgames.com',
    contactType: 'Customer Support',
  },
  sameAs: [
    BRAND_LINKS.discord,
    BRAND_LINKS.youtube,
    BRAND_LINKS.x,
    BRAND_LINKS.instagram,
    BRAND_LINKS.tiktok,
  ],
});
